$ = require 'jquery'
WarningBannerView = require 'views/header/warning-banner-view'
Auth = require 'db/auth'
template = require 'views/templates/header_enterprise_license'
track = require 'debug/track'
Util = require 'lib/util'

module.exports = class EnterpriseLicenseBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-license-banner')

  events:
    'click .js-dismiss-enterprise-license-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      maxMembers: @model.seats.max
      availableLicenses: @model.seats.available
    @$el.html template(data)

    @

  dismiss: (e) ->
    track("Header", "Enterprise License Banner", "Dismiss")
    Auth.me().dismissEnterpriseBannerFor @model.idEnterprise
    $(e.target).closest('.enterprise-license-banner').remove()
    e.preventDefault()



// WEBPACK FOOTER //
// ./app/scripts/views/header/enterprise-license-banner-view.coffee